import createVueComponent from '../createVueComponent';

const PlayCircle = createVueComponent('PlayCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polygon', { points: '10 8 16 12 10 16 10 8', key: '1cimsy' }],
]);

export default PlayCircle;
